declare const FIREBASE_API_KEY: string;
declare const FIREBASE_AUTH_DOMAIN: string;
declare const FIREBASE_DATABASE_URL: string;
declare const FIREBASE_PROJECT_ID: string;
declare const FIREBASE_STORAGE_BUCKET: string;
declare const FIREBASE_MESSAGING_SENDER_ID: string;
declare const FIREBASE_APP_ID: string;
declare const FIREBASE_MEASUREMENT_ID: string;

let db: any = null;

export enum FirebaseDataTypes {
  NOTIFICATION = 'notification',
}

/**
 * Lazily loads Firebase and returns the database instance.
 */
export async function getDb() {
  if (!db) {
    const [{ initializeApp }, { getDatabase }] = await Promise.all([
      import('firebase/app'),
      import('firebase/database'),
    ]);

    const firebaseConfig = {
      apiKey: FIREBASE_API_KEY,
      authDomain: FIREBASE_AUTH_DOMAIN,
      databaseURL: FIREBASE_DATABASE_URL,
      projectId: FIREBASE_PROJECT_ID,
      storageBucket: FIREBASE_STORAGE_BUCKET,
      messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
      appId: FIREBASE_APP_ID,
      measurementId: FIREBASE_MEASUREMENT_ID,
    };

    const app = initializeApp(firebaseConfig);
    db = getDatabase(app);
  }

  return db;
}

/**
 * Lazily loads Firebase and returns a database ref for the given query.
 */
export async function getFirebaseRef(query: string) {
  const [{ ref }, database] = await Promise.all([
    import('firebase/database'),
    getDb(),
  ]);
  return ref(database, query);
}
